<script lang="ts">
  import clsx from 'clsx';
  import { type Responsive } from '@athena-lib/responsive-utils';
  import { objectEntries } from '@athena-lib/object-utils';
  import { headingColors } from '@athena-lib/colors';
  import { getColorContext, lightColors } from '@athena-lib/container-context.svelte';
  import { getHeadingSizeClasses, type BaseHeadingProps } from './types';
  let { children, class: className, level, size, id, element, color }: BaseHeadingProps = $props();

  const levelsToElements = {
    1: 'h1',
    2: 'h2',
    3: 'h3',
    4: 'h4',
    5: 'h5',
  };

  const headingElement = $derived(element ?? levelsToElements[level]);

  const colorContext = getColorContext();

  const responsiveTextColors = $derived.by(() => {
    if (color) {
      return headingColors[color];
    }

    const contextBackground = colorContext.value;
    const responsiveTextObj: Responsive<string> = {
      lg:
        contextBackground.lg === 'brand'
          ? 'lg:text-st-black'
          : lightColors.includes(contextBackground.lg)
            ? 'lg:text-st-black'
            : 'lg:text-st-white',
      md:
        contextBackground.md === 'brand'
          ? 'md:text-st-black'
          : lightColors.includes(contextBackground.md)
            ? 'md:text-st-black'
            : 'md:text-st-white',
      sm:
        contextBackground.sm === 'brand'
          ? 'text-st-black'
          : lightColors.includes(contextBackground.sm)
            ? 'text-st-black'
            : 'text-st-white',
    };

    return objectEntries(responsiveTextObj)
      .map(([_, value]) => value)
      .join(' ');
  });

  const levelWeightClass = $derived(
    clsx({
      'font-black': [1, 2, 3].indexOf(level) !== -1,
      'font-bold': level === 4 || level === 5,
    }),
  );

  const baseClassName = $derived(
    clsx(responsiveTextColors, getHeadingSizeClasses(size), levelWeightClass, className),
  );
</script>

{#snippet renderChildren()}
  {#if typeof children === 'string'}
    {children}
  {:else}
    {@render children()}
  {/if}
{/snippet}

<svelte:element this={headingElement} class={baseClassName} {id}>
  {@render renderChildren()}
</svelte:element>
